###
  Show Bootstrap modal
###

class INTENT.utils.Modal

  @settings =
    title: ''
    size: "normal" # small, large
    buttons: [
        attr:
          class: "btn btn-link"
          type: "button"
          'data-dismiss': "modal"
        click: ->
        text: INTENT.utils.Helper.ucfirst (__ 'help.close')
    ]

  @SELECTOR_TEMPLATE_ID = "#utils_modal"

  @init: ->
    @bs_modal = $ "#{@SELECTOR_TEMPLATE_ID}"
    @bs_modal_title = @bs_modal.find ".modal-title"
    @bs_modal_body = @bs_modal.find ".modal-body"


  @set_size: (size) =>
    sizes =
      small: "modal-sm"
      normal: ""
      large: "modal-lg"

    if undefined == sizes[size]
      size = 'normal'

    @bs_modal.find ".modal-dialog"
      .removeClass "modal-sm modal-lg"
      .addClass sizes[size]



  @set_title: (title = '') =>
    if title instanceof jQuery
      @bs_modal_title.html title.text()
      return

    @bs_modal_title.html title

  @set_body: (body = '') =>
    if body instanceof jQuery
      @bs_modal_body.html body.get(0).outerHTML
      return

    @bs_modal_body.html body

  @update_buttons: (buttons = @settings.buttons) =>
    footer = @bs_modal.find ".modal-footer"
        .html ""
    for btn in buttons
      ($ "<button/>", btn).prependTo footer


  @show: (settings = {}) =>
    btns = []
    if 'buttons' of settings and settings.buttons.length
      for btn in settings.buttons
        btns.push btn
      delete settings.buttons
    for btn in @settings.buttons
      btns.push btn

    s = $.extend {}, @settings, settings
    s.buttons = btns

    @bs_modal.off 'hide.bs.modal'
    if 'function' == typeof s.onClose
      @bs_modal.on 'hide.bs.modal', ->
        s.onClose @bs_modal

    if not s.title and not s.body
      console.error "No reason to show empty modal"
      return

    @clear_contents()

    @update_buttons s.buttons

    @set_title s.title
    @set_body s.body

    @set_size s.size
    @bs_modal.modal "show"



  @close: =>
    @bs_modal.modal 'hide'

  @clear_contents: =>
    @bs_modal.find ".modal-body"
      .html ""
    @bs_modal.find ".modal-title"
      .html ""

  $ ->
    INTENT.utils.Modal.init();